
import React, {  } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import news from "../../static/news/ningbo.jpg"
import news1 from "../../static/news/ningbo1.jpg"
import news2 from "../../static/news/ningbo2.jpg"
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'3'} />
        <AboutTitle name={'新闻动态'} english={'NEWS'}  />
        <div className='newsCon'>
          <h3 className='title'>深圳市远东数智采技术服务有限公司（中国招标投标协会委员单位）参与协会第二届招标采购数字化专业委员会换届会议暨第一次工作会议</h3>
          <div className='time'>发布时间：2024-04-28</div>
          <div className='newsCon-con'>
            <p style={{textAlign:'center'}}><img src={news} /></p>
          <p>为深入学习贯彻党的二十大及二十届二中全会精神，加快建设全国统一大市场，深化要素市场化改革，建设高标准市场体系，积极推动招标采购数字化水平，促进行业数字化转型，4月19日，中国招标投标协会第二届招标采购数字化专业委员会换届会议暨第一次工作会议在宁波召开。中国招标投标协会会长任树本，执行副会长、首席专家李小林，副会长刘侠、彭耀军、王莉及79家第二届招标采购数字化专业委员会（以下简称专委会）委员单位代表出席会议。会议由中国招标投标协会秘书长陈琦主持。
          </p>
          <p style={{textAlign:'center'}}><img src={news1} /></p>
          <p>
会上，任树本会长表示，第一届专委会协助政府修订完善相关制度文件和标准规范、专题研究行业突出问题、展示交流优秀创新实践成果，做了大量卓有成效的工作，为推动招标采购交易数字化发展起到了示范作用。要求新一届专委会贯彻落实习近平总书记发展数字经济、建设数字强国重要精神，加强和规范招标采购数字化建设。一是强化责任意识，提高实践创新能力，推动数字化工作不断地迈向新台阶；二是加强行业引领，围绕行业难点、热点、堵点和问题开展专项调查研究，为完善制度、推出新政提供基础性、系统性支撑；三是依托2023数字化大会推广好经验好做法，不断完善、促进招标采购数字化；四是按照纵向深入、横向协同的原则加强与协会其他分支机构的合作交流，共谋协会发展。希望专委会在第二届主任带领下，继续发挥数字化优势，观大势、谋大局，为推动行业高质量发展做出新的贡献。
</p><p>
会议审议通过82家专委会委员单位及新修订的专委会工作规程，按照《中国招标投标协会分支机构管理办法》提名并表决通过李小林执行副会长当选专委会主任，国家电网有限公司等10家单位当选执行主任单位。会议向专委会主任、执行主任单位、委员单位颁发了证书。
</p>
<p style={{textAlign:'center'}}><img src={news2} /></p>
<p>

第二届专委会第一次工作会议上，全体与会委员代表围绕“发展数字经济，提升新质生产力的战略部署”、“建立统一大市场，建设高标准市场体系目标要求”、“中央经济工作会议稳中求进，先立后破”三个交流主题，结合招标投标实践中存在问题开展热烈探讨，共商新一届专委会工作思路，并将在下一次工作会议上研究部署具体工作任务目标。
</p><p>
与会代表纷纷表示，期待专委会发挥桥梁纽带作用，凝聚各方智慧，加快推进招标采购数字化领域相关管理办法和技术规范体系建设，更好地研究解决实际操作中的问题，为构建全国统一大市场，建设高标准市场体系，共建共治共享数字经济，助力发展新质生产力，协同推进产业链供应链采购绿色化和数字化转型融合和规范发展贡献新的力量。
</p>
          </div>
        </div>
      </PageBox>
    </>
  );
}
